const statusReasons = [
  { value: 'FRAUD', label: 'Fraud' },
  { value: 'ACCIDENT', label: 'Accident' },
  { value: 'DUPLICATE', label: 'Duplicate' },
  { value: 'LATEDRIVER', label: 'Late driver' },
  { value: 'PAYMENTISSUES', label: 'Payment issues' },
  { value: 'OFAC', label: 'Office of Foreign Assets Control' },
  { value: 'OTHERTERMSVIOLATION', label: 'Other Terms violation' },
  { value: 'BALANCEOUTSTANDING', label: 'Balance Outstanding' },
  { value: 'INACTIVE', label: 'Inactive' },
];

const accountDeletionStatus = {
  REQUESTED: 'REQUESTED',
  REJECTED: 'REJECTED',
  ACCEPTED: 'ACCEPTED',
  DELETED: 'DELETED',
};

export { statusReasons, accountDeletionStatus };
